import { ITask } from '@/types/task.interface'

export const sortListeners = (a: ITask, b: ITask) => {
	const aParts = a.source.split('-')
	const bParts = b.source.split('-')

	// short listeners first (listener-1), then long listeners (listener-en-1)
	if (aParts.length !== bParts.length) {
		return aParts.length - bParts.length
	}

	// then sort by numbers
	return Number(aParts[aParts.length - 1]) - Number(bParts[bParts.length - 1])
}
